import React from 'react';
import type { FC } from 'react';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { match } from 'variant';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { CommandOptions } from '../parse-command-options.js';
import { parseCommandOptions } from '../parse-command-options.js';
import { CreateHeadlessSiteCommand } from './CreateHeadlessSiteCommand.js';
import { validateAppFolder } from './ChooseFolder.js';

export const ProcessCommand: FC<{
  targetParentFolder: string;
  commandOptions: CommandOptions;
}> = ({ targetParentFolder, commandOptions }) => {
  const { status } = useAsync(async () => {
    const result = await parseCommandOptions(
      targetParentFolder,
      commandOptions
    );

    if (result.folderName) {
      const dirValidationResult = await validateAppFolder(
        targetParentFolder,
        result.folderName
      );
      if (dirValidationResult !== true) {
        throw new CliError({
          code: CliErrorCode.HeadlessArgumentIsInvalid({
            errorMessage: dirValidationResult,
          }),
          cause: undefined,
        });
      }
    }

    return result;
  }, []);

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner text="Loading..." />,
    Success: ({
      result: { template, folderName, businessName, cloudProviders, publish },
    }) => {
      return (
        <CreateHeadlessSiteCommand
          targetParentFolder={targetParentFolder}
          commandOptions={commandOptions}
          template={template}
          folderName={folderName}
          businessName={businessName}
          cloudProviders={cloudProviders}
          publish={publish}
        />
      );
    },
  });
};
